<nimbus-section-wrapper
  [sectionLabel]="TranslationKeys.AdminLicenses | translate"
  [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.userLicenses"
>
  <div class="input-license-checkbox-group-container">
    @for (item of options; track item) {
      @if (item.value.licenseType === LicenseType.AttendantConsole) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_attendant_console.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.attendantConsole"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensesAttendantConsole | translate"
          [infoLabel]="TranslationKeys.AdminLicenseDetailsAttendantConsole | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
      @if (item.value.licenseType === LicenseType.ContactCenter) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_contact_center.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.contactCenter"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensesContactCenter | translate"
          [infoLabel]="TranslationKeys.AdminLicensesContactCenterInfo | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
      @if (item.value.licenseType === LicenseType.WebInteract) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_interact.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.interact"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensesWebInteract | translate"
          [infoLabel]="TranslationKeys.AdminLicensesInteractInfo | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
      @if (item.value.licenseType === LicenseType.Assistant) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_nimbus_assistant.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.assistant"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensesAssistant | translate"
          [infoLabel]="TranslationKeys.AdminLicensesAssistantInfo | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
      @if (item.value.licenseType === LicenseType.Companion && (isCompanionAllowed$ | async)) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_companion.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.companion"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensingCompanion | translate"
          [infoLabel]="TranslationKeys.AdminLicensingCompanionInfo | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
      @if (item.value.licenseType === LicenseType.DirectCallHandling && (isDirectCallHandlingAllowed$ | async)) {
        <nimbus-user-input-license-checkbox-item
          image="images/shared_direct_call_handling.png"
          [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.directCallHandling"
          [isSelected]="item.value.isActive"
          [isDisabledByParent]="isDisabled"
          [value]="item.value.licenseType"
          [nimbusBulkValue]="item"
          [isBulk]="isBulk"
          [identical]="item.identical"
          [label]="TranslationKeys.AdminLicensingDirectCallHandling | translate"
          [infoLabel]="TranslationKeys.AdminLicensingDirectCallHandlingInfo | translate"
          [disabledReasons]="item.value.disabledReasons"
          [availableNumberOfLicenses]="item.value.availableLicenses"
          [selectedItemsCount]="selectedUsersCount"
          [itemsWithLicenseCount]="item.aggregatedCount"
          (selectionChange)="selectionChange($event)"
        ></nimbus-user-input-license-checkbox-item>
      }
    }
  </div>
</nimbus-section-wrapper>

<nimbus-section-wrapper
  [sectionLabel]="TranslationKeys.AdminUserDetailsModalities | translate"
  [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.userModalities"
>
  <ng-content select="[task-parallelization]"></ng-content>

  <ng-container [formGroup]="form">
    <div class="input-license-modalities">
      @if ((modalities$ | async)[LicenseType.AudioVideo]; as avModality) {
        <nimbus-form-row class="input-license-modality-row">
          <nimbus-form-control>
            <nimbus-user-input-license-modality-checkbox-item
              linkValue="audio-video"
              [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.audioVideo"
              [icon]="ICONS.PHONE_LIGHT"
              [isSelected]="avModality.value.isActive"
              [isDisabledByParent]="isDisabled"
              [isReadonly]="true"
              [value]="LicenseType.AudioVideo"
              [nimbusBulkValue]="avModality"
              [isBulk]="isBulk"
              [identical]="avModality.identical"
              [label]="TranslationKeys.AdminLicensingAudioVideo | translate"
              [infoLabel]="TranslationKeys.AdminLicenseAddonsAudioVideoDetails | translate"
              [disabledReasons]="avModality.value.disabledReasons"
              [availableNumberOfLicenses]="avModality.value.availableLicenses"
              [selectedItemsCount]="selectedUsersCount"
              [itemsWithLicenseCount]="avModality.aggregatedCount"
              (selectionChange)="selectionChange($event)"
            />
          </nimbus-form-control>
          <nimbus-form-control>
            <nimbus-input-number
              id="audioTaskLimit"
              formControlName="audioTaskLimit"
              [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.modalityTaskLimit"
              [isDisabled]="
                isDisabled ||
                !isTaskParallelizationEnabled ||
                !avModality.value.isActive ||
                (isBulk && avModality.aggregatedCount !== selectedUsersCount)
              "
              [class.bulk-edit]="isBulk"
              [class.bulk-edit-equal]="isBulk && taskLimitIdentical['audioTaskLimit']"
              [class.bulk-edit-not-equal]="isBulk && !taskLimitIdentical['audioTaskLimit']"
              [label]="TranslationKeys.AdminTPModalityTaskLimit | translate"
              [placeholder]="taskLimitPlaceholders['audioTaskLimit']"
              [required]="!isBulk && isTaskParallelizationEnabled && avModality.value.isActive"
              [min]="taskLimitMin"
              [max]="(modalityTaskLimitMax$ | async) ?? taskLimitMax"
              floatLabel="always"
            ></nimbus-input-number>
          </nimbus-form-control>
        </nimbus-form-row>
      }

      @if (isInstantMessagingAllowed$ | async) {
        @if ((modalities$ | async)[LicenseType.InstantMessaging]; as imModality) {
          <nimbus-form-row>
            <nimbus-form-control>
              <nimbus-user-input-license-modality-checkbox-item
                linkValue="instant-messaging"
                [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.instantMessaging"
                [icon]="ICONS.COMMENT_ALT_LIGHT"
                [isSelected]="imModality.value.isActive"
                [isDisabledByParent]="isDisabled"
                [value]="LicenseType.InstantMessaging"
                [nimbusBulkValue]="imModality"
                [isBulk]="isBulk"
                [identical]="imModality.identical"
                [label]="TranslationKeys.AdminLicensingInstantMessaging | translate"
                [infoLabel]="TranslationKeys.AdminLicenseAddonsInstantMessagingDetails | translate"
                [disabledReasons]="imModality.value.disabledReasons"
                [availableNumberOfLicenses]="imModality.value.availableLicenses"
                [selectedItemsCount]="selectedUsersCount"
                [itemsWithLicenseCount]="imModality.aggregatedCount"
                (selectionChange)="selectionChange($event)"
              />
            </nimbus-form-control>
            <nimbus-form-control>
              <nimbus-input-number
                id="instantMessagingTaskLimit"
                formControlName="instantMessagingTaskLimit"
                [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.modalityTaskLimit"
                [isDisabled]="
                  isDisabled ||
                  !isTaskParallelizationEnabled ||
                  !imModality.value.isActive ||
                  (isBulk && imModality.aggregatedCount !== selectedUsersCount)
                "
                [class.bulk-edit]="isBulk"
                [class.bulk-edit-equal]="isBulk && taskLimitIdentical['instantMessagingTaskLimit']"
                [class.bulk-edit-not-equal]="isBulk && !taskLimitIdentical['instantMessagingTaskLimit']"
                [label]="TranslationKeys.AdminTPModalityTaskLimit | translate"
                [placeholder]="taskLimitPlaceholders['instantMessagingTaskLimit']"
                [required]="!isBulk && isTaskParallelizationEnabled && imModality.value.isActive"
                [min]="taskLimitMin"
                [max]="(modalityTaskLimitMax$ | async) ?? taskLimitMax"
                floatLabel="always"
              ></nimbus-input-number>
            </nimbus-form-control>
          </nimbus-form-row>
        }
      }

      @if ((modalities$ | async)[LicenseType.ExternalTask]; as etModality) {
        <nimbus-form-row class="input-license-modality-row">
          <nimbus-form-control>
            <nimbus-user-input-license-modality-checkbox-item
              linkValue="external-task"
              [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.externalTask"
              [icon]="ICONS.EXTERNAL_TASK_LIGHT"
              [isSelected]="etModality.value.isActive"
              [isDisabledByParent]="isDisabled"
              [value]="LicenseType.ExternalTask"
              [nimbusBulkValue]="etModality"
              [isBulk]="isBulk"
              [identical]="etModality.identical"
              [label]="TranslationKeys.AdminLicensingExternalTask | translate"
              [infoLabel]="TranslationKeys.AdminLicenseAddonsExternalTaskDetails | translate"
              [disabledReasons]="etModality.value.disabledReasons"
              [availableNumberOfLicenses]="etModality.value.availableLicenses"
              [selectedItemsCount]="selectedUsersCount"
              [itemsWithLicenseCount]="etModality.aggregatedCount"
              (selectionChange)="selectionChange($event)"
            />
          </nimbus-form-control>
          <nimbus-form-control>
            <nimbus-input-number
              id="externalTaskLimit"
              formControlName="externalTaskLimit"
              [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.modalityTaskLimit"
              [isDisabled]="
                isDisabled ||
                !isTaskParallelizationEnabled ||
                !etModality.value.isActive ||
                (isBulk && etModality.aggregatedCount !== selectedUsersCount)
              "
              [class.bulk-edit]="isBulk"
              [class.bulk-edit-equal]="isBulk && taskLimitIdentical['externalTaskLimit']"
              [class.bulk-edit-not-equal]="isBulk && !taskLimitIdentical['externalTaskLimit']"
              [label]="TranslationKeys.AdminTPModalityTaskLimit | translate"
              [placeholder]="taskLimitPlaceholders['externalTaskLimit']"
              [required]="!isBulk && isTaskParallelizationEnabled && etModality.value.isActive"
              [min]="taskLimitMin"
              [max]="(modalityTaskLimitMax$ | async) ?? taskLimitMax"
              floatLabel="always"
            ></nimbus-input-number>
          </nimbus-form-control>
        </nimbus-form-row>
      }

      @if (isEmailAllowed$ | async) {
        @if ((modalities$ | async)[LicenseType.Email]; as emailModality) {
          <nimbus-form-row class="input-license-modality-row">
            <nimbus-form-control>
              <nimbus-user-input-license-modality-checkbox-item
                linkValue="email"
                [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.email"
                [icon]="ICONS.ENVELOPE_LIGHT"
                [isSelected]="emailModality.value.isActive"
                [isDisabledByParent]="isDisabled"
                [value]="LicenseType.Email"
                [nimbusBulkValue]="emailModality"
                [isBulk]="isBulk"
                [identical]="emailModality.identical"
                [label]="TranslationKeys.AdminLicensingEmail | translate"
                [infoLabel]="TranslationKeys.AdminLicenseAddonsEmailDetails | translate"
                [disabledReasons]="emailModality.value.disabledReasons"
                [availableNumberOfLicenses]="emailModality.value.availableLicenses"
                [selectedItemsCount]="selectedUsersCount"
                [itemsWithLicenseCount]="emailModality.aggregatedCount"
                (selectionChange)="selectionChange($event)"
              />
            </nimbus-form-control>
            <nimbus-form-control>
              <nimbus-input-number
                id="emailTaskLimit"
                formControlName="emailTaskLimit"
                [nimbusPermissionsFieldDescriptorAssert]="UserGeneralTabFields.modalityTaskLimit"
                [isDisabled]="
                  isDisabled ||
                  !isTaskParallelizationEnabled ||
                  !emailModality.value.isActive ||
                  (isBulk && emailModality.aggregatedCount !== selectedUsersCount)
                "
                [class.bulk-edit]="isBulk"
                [class.bulk-edit-equal]="isBulk && taskLimitIdentical['emailTaskLimit']"
                [class.bulk-edit-not-equal]="isBulk && !taskLimitIdentical['emailTaskLimit']"
                [label]="TranslationKeys.AdminTPModalityTaskLimit | translate"
                [placeholder]="taskLimitPlaceholders['emailTaskLimit']"
                [required]="!isBulk && isTaskParallelizationEnabled && emailModality.value.isActive"
                [min]="taskLimitMin"
                [max]="(modalityTaskLimitMax$ | async) ?? taskLimitMax"
                floatLabel="always"
              ></nimbus-input-number>
            </nimbus-form-control>
          </nimbus-form-row>
        }
      }
    </div>
  </ng-container>

  <ng-content select="[allow-task-activation-while-in-active-task]"></ng-content>
</nimbus-section-wrapper>

@if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
  <mat-error>
    <i class="error-triangle" [nimbusIcon]="icons.EXCLAMATION_TRIANGLE"></i>
    <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
  </mat-error>
}
